<div class="topdiv" [style.background-color]="backgroundColorScreen" >
    <div class="agGridOuterDiv">
      <div>
  
  
          <!-- <div class="col-lg-12" style="margin-top: 3%;">
  
            Mapping Objects
  
          </div> --> 
        <div class="row topRowMargins headerStyle" style="
          margin-right: 0;
          margin-left: 0;
          margin-top: 5%;
          ">
          <label i18n="@@spmsUserReg" class="textColour">Objects Mapping</label>
          <span class="example-spacer"></span>
          <nav mat-tab-nav-bar mat-stretch-tabs>
            <a
              mat-tab-link
              *ngFor="let link of navLinks"
              [routerLink]="getRouterLink(link)"
              [queryParams]="getQueryParams(link.label)"
              [active]="link.label === 'Objects Mapping'"
              style="min-width:130px; opacity: 1;"
              rel="noopener"
            >
              {{ link.label }}
            </a>
          </nav>
        </div>
  
      </div>
      <div style="margin-top: 25px;">
        <form novalidate [formGroup]='validations_form'>
          <div class="row">
            <div class="col-lg-6">
              <mat-form-field appearance="outline">
  <mat-label i18n="@@RCFormulaexpression">Source</mat-label>
  <input
      matInput
      [ngModelOptions]="{standalone:true}"
      [(ngModel)]="sourcedns"
      required
      placeholder="Enter Source"
      title="Source"
      readonly
  />
  <!-- <mat-select [ngModelOptions]="{standalone:true}"  [(ngModel)]="sourcedns" (ngModelChange)="selectDns($event)"   title="Source" required>
    <mat-option style="font-size: 15px;" *ngFor="let eachdns of dnsnames" [value]="eachdns.envname" >
        {{eachdns.envname}}
    </mat-option>
  </mat-select> -->
  <!-- <mat-error *ngFor="let validation of validation_messages.compname" >
    <span
      *ngIf="validations_form.get('compname').hasError(validation.type) && (validations_form.get('compname').dirty || validations_form.get('compname').touched)">
      {{ validation.message }}
    </span>
  </mat-error> -->
</mat-form-field>
</div>
<div class="col-lg-6">
  <mat-form-field appearance="outline">
    <mat-label i18n="@@TMSTAFFMASTERfirstname">Target</mat-label>
    <input
        matInput
        [ngModelOptions]="{standalone:true}"
        [(ngModel)]="targetdns"
        required
        placeholder="Enter Target"
        title="Target"
        readonly
    />
    <!-- <mat-select [ngModelOptions]="{standalone:true}" [(ngModel)]="targetdns" (ngModelChange)="selectTargetDns($event)" required title="Target">
      <mat-option style="font-size: 15px;" *ngFor="let eachtargetdns of targetdnsnames" [value]="eachtargetdns.envname" >
        {{eachtargetdns.envname}}
      </mat-option>
    </mat-select> -->
    <!-- <mat-error *ngFor="let validation of validation_messages.username">
      <span
        *ngIf="validations_form.get('username').hasError(validation.type) && (validations_form.get('username').dirty || validations_form.get('username').touched)">
        {{ validation.message }}
      </span>
    </mat-error> -->
  </mat-form-field>
            </div>
          </div>
          <div class="row" *ngIf="butttonname === 'Update Map'">
            <div class="col-lg-6">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@RCFormulaexpression">Selected Stage / Source Objects</mat-label>
                <input
                    matInput
                    [ngModelOptions]="{standalone:true}"
                    [(ngModel)]="mappingCreationData.stageobject"
                    required
                    placeholder="Enter Source"
                    title="Source"
                    readonly
                  />
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@TMSTAFFMASTERfirstname">Selected Target Objects</mat-label>
                <input
                matInput
                [ngModelOptions]="{standalone:true}"
                [(ngModel)]="mappingCreationData.targetobject"
                required
                placeholder="Enter Target"
                title="Target"
                readonly
              />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
              <div class="col-3">
              <mat-form-field appearance="outline">
                 <mat-label i18n="@@TMSTAFFMASTERfirstname">Order Id</mat-label>
                <input 
                matInput 
                type="number" 
                placeholder="Order Id"
                [ngModelOptions]="{standalone:true}"
                [(ngModel)]="orderId" 
                #orderIdCtrl="ngModel"
                maxlength="100"
                required>
                <mat-error *ngIf="orderIdCtrl.hasError('required') && orderIdCtrl.touched">
                  Order Id is required
                </mat-error>
                <mat-error *ngIf="orderIdCtrl.hasError('maxlength')">
                  Order Id cannot exceed 100 digits
                </mat-error>
              </mat-form-field>
            </div>
             <div class="col-3" style="text-align: center;">
              <mat-form-field class="filter" appearance="outline">
                <mat-label i18n="@@targetloginusername">
                  Object Group
                </mat-label>
                <!-- formControlName="" -->
                <mat-select [ngModelOptions]="{standalone:true}" [(ngModel)]="objectGroupNameId" (selectionChange)="onObjectGroupChange($event)" #objectGroupNameCtrl="ngModel" [disabled]="butttonname === 'Update Map'" required>
                      <span  *ngFor="let data of objectGroupData">
                <mat-option  *ngIf="data.status == 'Yes'"
                  [value]="data.objectGroupId"
                >
                {{data.objectGroupName}}
                </mat-option>
                </span>
                </mat-select>
                <mat-error *ngIf="objectGroupNameCtrl.hasError('required') && objectGroupNameCtrl.touched">
                  Object Group is required
                </mat-error>
            </mat-form-field>
            </div>
          

            <div class="col-3" style="text-align: center;">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@TMSTAFFMASTERfirstname">Source UI Section</mat-label>
                <input matInput type="text" placeholder="Source UI Section"
                  [(ngModel)]="Source_UI_Section" [ngModelOptions]="{standalone:true}"
                  #sourceUISectionCtrl="ngModel"
                  required>
                <mat-error *ngIf="sourceUISectionCtrl.hasError('required') && sourceUISectionCtrl.touched">
                  Source UI Section is required
                </mat-error>
              </mat-form-field>
            </div>
            
            <div class="col-3" style="text-align: center;">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@TMSTAFFMASTERfirstname">Target UI Section</mat-label>
                <input matInput type="text" placeholder="Target UI Section"
                  [(ngModel)]="Target_UI_Section" [ngModelOptions]="{standalone:true}"
                  #targetUISectionCtrl="ngModel"
                  required>
                <mat-error *ngIf="targetUISectionCtrl.hasError('required') && targetUISectionCtrl.touched">
                  Target UI Section is required
                </mat-error>
              </mat-form-field>
            </div>
                     <!--
                        Sujeet Kumar
                        21/11/2025
                        Added dropdown in Object Mapping screen to allow users
                        to select whether Validation Report is required (Yes/No).
                      -->

             </div>
              
        </form>
      </div>
  
      <div class="row" *ngIf="butttonname !== 'Update Map'">
        <div style="width: 49%;">
          <div class="seperateDiv" >
            <ag-grid-angular class="ag-theme-balham table-width-fields
              tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="columnDefsForObjects"
              [rowData]="rowData"
              [animateRows]="true"
              [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true"
              [rowSelection]="rowSelection" [rowHeight]="35" [headerHeight]="35"
              [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
              [enableRangeSelection]="true" [debug]="true"
              (gridReady)="onGridReadyForObjects($event,sourcednsid)"
              (rowSelected)="onSourceRowSelected($event)"
               [hidden]="!true">
               >
            </ag-grid-angular>
          </div>
        </div>
        <div style="width: 1%;">

        </div>
        <div style="width: 49%;">
          <div class="seperateDiv">
            <ag-grid-angular class="ag-theme-balham table-width-fields
              tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="columnDefsForTargetObjects" 
              [rowData]="targetData"
              [animateRows]="true"
              [defaultColDef]="defaultTargetColDef" [suppressPaginationPanel]="true"
              [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35" [headerHeight]="35"
              [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
              [enableRangeSelection]="true" [debug]="true"
              (gridReady)="onGridReadyForTargetObjects($event,targetdnsid)"
              (rowSelected)="onTargetRowSelected($event)"
          
            
               >
            </ag-grid-angular>
          </div>
        </div>
      </div>


 
 <div class="row" style="margin-top: 15px;">
           
               <div class="col-3" style="text-align: center;">
                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>Is Validation Report Required</mat-label>
                  <mat-select [(ngModel)]="activeFlag" [ngModelOptions]="{standalone: true}"
                  (selectionChange)="isvalidationRequired($event.value)">
                    
                    <mat-option value="Yes">Yes</mat-option>
                    <mat-option value="No">No</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-3" style="text-align: center;"></div>
              <div class="col-3" style="text-align: center;"></div>
              <div class="col-3" style="text-align: center;"></div>

    </div>

    

<div class="dropdown-container" [class.disabled-div]="!isDropdownEnabled">

  <mat-icon 
    class="info-icon"
    matTooltip="These fields will be enabled only after Source and Target are selected and Validation is set to Yes.
Please ensure that the same order is maintained across all dropdown selections.">
    info
  </mat-icon>

  <div class="row" style="margin-top: 10px;">

    <!-- COLUMN 1 -->
    <div class="col-4">

      <!-- Source Parent Key -->
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Source Parent Object Key Column</mat-label>

        <mat-select 
          [(ngModel)]="selectedParentKeys"
          [ngModelOptions]="{standalone:true}"
          [disabled]="!isDropdownEnabled"
          multiple
          [required]="activeFlag === 'Yes'"
          #sourceParentCtrl="ngModel">

          <mat-select-trigger>
            {{ selectedParentKeys?.join(', ') }}
          </mat-select-trigger>

          <mat-option 
            *ngFor="let attr of objectAttributesList" 
            [value]="attr"
            (onSelectionChange)="onOptionToggle($event, attr, 'sourceParent')">
            {{ attr }}
          </mat-option>

        </mat-select>

        <mat-error *ngIf="sourceParentCtrl.invalid && sourceParentCtrl.touched">
          Required
        </mat-error>
      </mat-form-field>

      <!-- Source Parent Name -->
      <mat-form-field appearance="outline" style="width: 100%; margin-top:10px;">
        <mat-label>Source Parent Object Name</mat-label>

        <mat-select 
          [(ngModel)]="selectedSourceParentObjectNames"
          [ngModelOptions]="{standalone:true}"
          [disabled]="!isDropdownEnabled"
          
          [required]="activeFlag === 'Yes'"
          #sourceParentNameCtrl="ngModel">

          

          <mat-option 
            *ngFor="let obj of sourceParentObjectNameList" 
            [value]="obj">
            {{ obj }}
          </mat-option>

        </mat-select>

        <mat-error *ngIf="sourceParentNameCtrl.invalid && sourceParentNameCtrl.touched">
          Required
        </mat-error>
      </mat-form-field>

    </div>


    <!-- COLUMN 2 -->
    <div class="col-4">

      <!-- Transform Parent Key -->
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Transform Parent Object Key Column</mat-label>

        <mat-select 
          [(ngModel)]="selectedTransformParentKeys"
          [ngModelOptions]="{standalone:true}"
          [disabled]="!isDropdownEnabled"
          multiple
          [required]="activeFlag === 'Yes'"
          #transformParentCtrl="ngModel">

          <mat-select-trigger>
            {{ selectedTransformParentKeys?.join(', ') }}
          </mat-select-trigger>

          <mat-option 
            *ngFor="let attr of targetObjectAttributesList" 
            [value]="attr"
            (onSelectionChange)="onOptionToggle($event, attr, 'transformParent')">
            {{ attr }}
          </mat-option>

        </mat-select>

        <mat-error *ngIf="transformParentCtrl.invalid && transformParentCtrl.touched">
          Required
        </mat-error>
      </mat-form-field>

      <!-- Transform Primary Key -->
      <mat-form-field appearance="outline" style="width: 100%; margin-top:10px;">
        <mat-label>Transform Object Primary Key Column</mat-label>

        <mat-select 
          [(ngModel)]="selectedTransformPrimaryKeys"
          [ngModelOptions]="{standalone:true}"
          [disabled]="!isDropdownEnabled"
          multiple
          [required]="activeFlag === 'Yes'"
          #transformPrimaryCtrl="ngModel">

          <mat-select-trigger>
            {{ selectedTransformPrimaryKeys?.join(', ') }}
          </mat-select-trigger>

          <mat-option 
            *ngIf="selectedFieldsData?.length && targetselectedFieldsData?.length"
            [value]="selectedFieldsData[0].objectname + '_' + targetselectedFieldsData[0].objectname + '_id'"
            (onSelectionChange)="onOptionToggle($event, selectedFieldsData[0].objectname + '_' + targetselectedFieldsData[0].objectname + '_id', 'transformPrimary')">
            {{ selectedFieldsData[0].objectname + '_' + targetselectedFieldsData[0].objectname + '_id' }}
          </mat-option>

          <mat-option 
            *ngFor="let attr of targetObjectAttributesList" 
            [value]="attr"
            (onSelectionChange)="onOptionToggle($event, attr, 'transformPrimary')">
            {{ attr }}
          </mat-option>

        </mat-select>

        <mat-error *ngIf="transformPrimaryCtrl.invalid && transformPrimaryCtrl.touched">
          Required
        </mat-error>
      </mat-form-field>

    </div>


    <!-- COLUMN 3 -->
    <div class="col-4">

      <!-- Target Parent Key -->
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Target Parent Object Key Column</mat-label>

        <mat-select 
          [(ngModel)]="selectedTargetParentKeys"
          [ngModelOptions]="{standalone:true}"
          [disabled]="!isDropdownEnabled"
          multiple
          [required]="activeFlag === 'Yes'"
          #targetParentCtrl="ngModel">

          <mat-select-trigger>
            {{ selectedTargetParentKeys?.join(', ') }}
          </mat-select-trigger>

          <mat-option 
            *ngFor="let attr of targetObjectAttributesList" 
            [value]="attr"
            (onSelectionChange)="onOptionToggle($event, attr, 'targetParent')">
            {{ attr }}
          </mat-option>

        </mat-select>

        <mat-error *ngIf="targetParentCtrl.invalid && targetParentCtrl.touched">
          Required
        </mat-error>
      </mat-form-field>

      <!-- Target Primary Key -->
      <mat-form-field appearance="outline" style="width: 100%; margin-top:10px;">
        <mat-label>Target Object Primary Key Column</mat-label>

        <mat-select 
          [(ngModel)]="selectedTargetPrimaryKeys"
          [ngModelOptions]="{standalone:true}"
          [disabled]="!isDropdownEnabled"
          multiple
          [required]="activeFlag === 'Yes'"
          #targetPrimaryCtrl="ngModel">

          <mat-select-trigger>
            {{ selectedTargetPrimaryKeys?.join(', ') }}
          </mat-select-trigger>

          <mat-option 
            *ngFor="let attr of targetObjectAttributesList" 
            [value]="attr"
            (onSelectionChange)="onOptionToggle($event, attr, 'targetPrimary')">
            {{ attr }}
          </mat-option>

        </mat-select>

        <mat-error *ngIf="targetPrimaryCtrl.invalid && targetPrimaryCtrl.touched">
          Required
        </mat-error>
      </mat-form-field>

    </div>

  </div>
</div>


<!-- Target Object Name -->
<div class="col-4" style="margin-top: 20px;">
  <mat-form-field appearance="outline" style="width: 100%;">
    
    <mat-label>Target Object Name</mat-label>

    <mat-select 
      [(ngModel)]="selectedTargetObjectName"
      [ngModelOptions]="{standalone:true}"
      
      #targetObjectNameCtrl="ngModel">

      <!-- 🔍 SEARCH BOX -->
      <mat-option>
        <input 
          matInput 
          placeholder="Search..."
          [(ngModel)]="searchText"
          (ngModelChange)="filterTargetObjects()"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
          style="width: 100%; border: none; outline: none;">
      </mat-option>

      <!--  No Data Found -->
      <mat-option *ngIf="filteredTargetObjectList.length === 0" disabled>
        No matching results
      </mat-option>

      <!--  FILTERED LIST -->
      <mat-option 
        *ngFor="let obj of filteredTargetObjectList" 
        [value]="obj.objectname">
        
        {{ obj.objectlabel }}

      </mat-option>

    </mat-select>

    

  </mat-form-field>
</div>

      <div class="col-lg">
        <div class="container" style="text-align: center;">
          <!-- <div class="row topRowMargins"> -->
            <span class="example-spacer"></span>
            <div  style=" display: inline-flex; width: 40%; height:fit-content; margin-top: 1rem;" >
              <button *ngIf="butttonname !== 'Update Map'" i18n="@@TMRunButton" type="button"
                [style.background-color]="buttonColor"
                class="actionButton btn btn-rounded-button z-depth-1
                waves-effect waves-light text-capitalize" style="padding:
                .3rem 1.6rem;font-size: .85rem;width:100%;" id="101"  (click)="map(orderIdCtrl,sourceUISectionCtrl,targetUISectionCtrl,sourceParentCtrl,sourceParentNameCtrl,transformParentCtrl,transformPrimaryCtrl,targetParentCtrl,targetPrimaryCtrl,targetObjectNameCtrl)">Map</button>
                  <button *ngIf="butttonname === 'Update Map'" i18n="@@TMRunButton" type="button"
                  [style.background-color]="buttonColor"
                  class="actionButton btn btn-rounded-button z-depth-1
                  waves-effect waves-light text-capitalize" style="padding:
                  .3rem 1.6rem;font-size: .85rem;width:100%;" id="101"  (click)="updateMapping(orderIdCtrl,sourceUISectionCtrl,targetUISectionCtrl,sourceParentCtrl, sourceParentNameCtrl, transformParentCtrl, transformPrimaryCtrl, targetParentCtrl, targetPrimaryCtrl, targetObjectNameCtrl)">Update Mapping</button>
              <button i18n="@@TMRunButton" type="button"
                [style.border-color]="buttonColor"
                class="cancelButton btn btn-rounded-button z-depth-1
                waves-effect waves-light text-capitalize" style="padding:
                .3rem 1.6rem;font-size: .85rem;width:100%;" (click)="cancel(orderIdCtrl,objectGroupNameCtrl,sourceUISectionCtrl,targetUISectionCtrl)">Cancel</button>
            </div>
            <span class="example-spacer"></span> 
        </div>
      </div>


      <!--grid data-->
      <div>
        <mat-toolbar class="agGridtoperDiv card" style="
          background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8;
        border-right: 1px solid #a9a9a9a8;
        border-left: 1px solid #a9a9a9a8;">
        <label i18n="@@spmsUserReg" class="textColour">Mapping</label>
        <span class="example-spacer"></span>
       
        
<!-- ========================================================== -->

        <button class="popup gridColour btn btn-rounded-button z-depth-1
        waves-effect waves-light text-capitalize"[style.background-color]="buttonColor"
        [style.min-width.px]="100" style="font-size: 12px; padding: 4px 10px; height: 32px;" id="102"  title="Import Data"
          (click)="importData()">
          Import
          <em class="fas fa-download" style="font-size: 12px; padding: 0 5px;" title="Import Data"></em>
        </button>
        <!-- Import Button -->
        <button class="popup gridColour btn btn-rounded-button z-depth-1
                               waves-effect waves-light text-capitalize" [style.background-color]="buttonColor"
          [style.min-width.px]="100" style="font-size: 12px; padding: 4px 10px; height: 32px;"id="103" title="Export Data"
          (click)="exportData()">
          Export
          <em class="fas fa-upload" style="font-size: 12px; padding: 0 5px;" title="Export Data"></em>
        </button>

        <!-- ================================================ -->
        <button class="refreshrunButton popup gridColour btn btn-rounded-button
  z-depth-1 waves-effect waves-light text-capitalize"
  [style.background-color]="buttonColor" title="Refresh"
  [style.min-width.px]="100"
  (click)="refreshRun()"
  style="font-size: 12px; padding: 4px 10px; height: 32px;">
  Refresh
  <em class="fas fa-refresh" style="font-size: 12px; padding: 0 5px;"></em>
</button>

<button class="popup gridColour btn btn-rounded-button z-depth-1
waves-effect waves-light text-capitalize"
[style.background-color]="buttonColor" title="Download"
(click)="onBtExport()"
[style.min-width.px]="100"
style="font-size: 12px; padding: 4px 10px; height: 32px;">
Download
<em class="fas fa-download example-icon" style="font-size: 12px; padding: 0 5px;"></em>
</button>




        <div class="insertPageNoDiv">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@spmsUserRegpageno">Page No</mat-label>
            <input matInput type="text"
              (input)="onSearchChange($event.target.value)">
          </mat-form-field>
        </div>

        <div class="selectRecordsDiv" style="width:9.5%">
          <mat-form-field appearance="outline" style="width:100%">
            <mat-label i18n="@@spmsUserRegrecords" style="color:black">Records</mat-label>
            <mat-select [(ngModel)]="pagesize"
              (ngModelChange)="onPageSizeChanged()">
              <mat-option value="10" selected>10</mat-option>
              <mat-option value="200">200</mat-option>
              <mat-option value="300">300</mat-option>
              <mat-option value="400">400</mat-option>
            </mat-select>

          </mat-form-field>
        </div>
        <div class="card pagination paginationFirstButton
          paginationFirstlastButton">
          <em class="fas fa-angle-double-left waves-effect waves-light"
            (click)="onBtFirst()"></em>
        </div>
        <div class="card pagination paginationButtons btn-rounded">
          <ul>
            <li class="paginationliicon"><em class="fas fa-angle-left
                waves-effect waves-light"
                (click)="onBtPrevious()"></em></li>
            <li>{{currentpage}}/{{totalpages}}</li>
            <li class="paginationliicon" style="padding:0;"><em
                class="fas fa-angle-right waves-effect waves-light"
                (click)="onBtNext()"></em></li>
          </ul>
        </div>
        <div class="card pagination paginationLastButton
          paginationFirstlastButton">
          <em class="fas fa-angle-double-right waves-effect waves-light"
            (click)="onBtLast()"></em>
        </div>


        </mat-toolbar>


      </div>

      <ag-grid-angular class="ag-theme-balham table-width tablestyles square
      scroolbar-dusty-grass square thin"
      style="width: 100%; height: 65vh;"
      [columnDefs]="columnDefs" [animateRows]="true"
      [pagination]="true" [defaultColDef]="defaultMappingColDef"
      [rowData]="mappingGrid"
      [suppressPaginationPanel]="true" [rowHeight]="35"
      [headerHeight]="35" [enableBrowserTooltips]="true"
      [floatingFiltersHeight]="45"
      [paginationPageSize]="paginationPageSize"
      [paginationNumberFormatter]="paginationNumberFormatter"
      [enableRangeSelection]="true" [debug]="true"
      [rowClassRules]="rowClassRules"
      [getRowStyle]="getRowStyle"
      (paginationChanged)="onPaginationChanged()"
      [components]="components"
      (gridReady)="onGridReady($event)"
       >
    </ag-grid-angular>



    </div>
  </div>
  
